import React from "react"
import ClientService from "../../../../services/ClientService"
import ClientContext from "../../../../providers/CurrentClientProvider"
import {Typography, TextField, Button, Card, CardHeader, CardContent} from "@mui/material"
import {useForm} from 'react-hook-form'

const cssInJs = {
    header: {
        backgroundColor: "#422e52",
        color: "#fff",
        fontSize: '14px'
    },
    subheader: {
        color: "#fff",
        fontSize: '13px'
    },
    warning: {
        backgroundColor: '#FFE264',
        marginTop: '-16px',
        marginBottom: 0,
        marginLeft: '-16px',
        marginRight: '-16px',
        padding: '10px',
        fontSize: '13px'
    },
    textInput: {
        marginBottom: '15px'
    }
}

const GeneralClientCreateForm = (props) => {

    const {setSetupMode} = props
    const client_context = ClientContext.useClient()

    const {
        register,
        handleSubmit,
        watch,
        formState: {
            errors,
            isValid,
            isValidating,
            dirtyFields,
            isSubmitting
        }
    } = useForm({
        mode: 'onChange'
    })

    async function onSubmit(data) {
        try {
            const sample_client_code = await ClientService.createNewClient(data)
            setSetupMode("edit")
            client_context.setClient(sample_client_code)
        } catch (e) {
            console.log('error', e)
        }
    }

    const formDataWatched = watch()

    const isHeaderVisible = formDataWatched.client_code && formDataWatched.name
    const isWarningVisible = 'client_code' in dirtyFields && 'name' in dirtyFields
    const isSubmitButtonDisabled = !(isValid && !isSubmitting && !isValidating)

    return (
        <Card>
            {isHeaderVisible && <CardHeader
                title={formDataWatched.name}
                subheader={formDataWatched.client_code}
                subheaderTypographyProps={{
                    sx: cssInJs.subheader
                }}
                sx={cssInJs.header}
            />}
            <CardContent>
                {isWarningVisible && <Typography sx={cssInJs.warning}>You have unsaved changes, please hit save before
                    continuing.</Typography>}
                <form onSubmit={handleSubmit(onSubmit)} noValidate>
                    <Typography variant="h4" gutterBottom>
                        General
                    </Typography>
                    <div>
                        <TextField
                            id="standard-basic"
                            label="Client code"
                            variant="standard"
                            fullWidth
                            sx={cssInJs.textInput}
                            {...register('client_code', {
                                required: "Name is required",
                                validate: async (client_code) => {
                                    if (client_code === formDataWatched.client_code) {
                                        return errors.client_code ? errors.client_code.message : true
                                    }

                                    const _client = await ClientService.getClientByCode(client_code, 1)
                                    return !_client || `Client Code Exists: ${client_code}`
                                }
                            })}
                            error={Boolean(errors.client_code)}
                            helperText={errors.client_code?.message}
                        />
                    </div>

                    <div>
                        <TextField
                            id="standard-basic"
                            label="Name"
                            variant="standard"
                            fullWidth
                            {...register('name', {
                                required: "Name is required"
                            })}
                            sx={cssInJs.textInput}
                            error={Boolean(errors.name)}
                            helperText={errors.name?.message}
                        />
                    </div>
                    <Button
                        variant="contained"
                        type="submit"
                        disabled={isSubmitButtonDisabled}
                    >
                        Save Client Profile
                    </Button>
                </form>
            </CardContent>
        </Card>
    )
}

export default GeneralClientCreateForm
